// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","571":"settings","966":"dashboard"}[chunkId] + "." + {"177":"e7e0a838","571":"f4b95ad1","966":"875e3758"}[chunkId] + ".css";
};